import React from "react";
import { Lottie } from "@crello/react-lottie";
import styled from "styled-components";
import PropTypes from "prop-types";

const LottieWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LottieControl = ({
  playState,
  animation,
  isLoop,
  isAuto,
  speed,
  direction,
  width,
  height,
}) => {
  return (
    <LottieWrapper>
      <Lottie
        config={{ animationData: animation, loop: isLoop, autoplay: isAuto }}
        height={height}
        width={width}
        playingState={playState}
        speed={speed}
        direction={direction}
      />
    </LottieWrapper>
  );
};

export default LottieControl;

LottieControl.propTypes = {
  playState: PropTypes.string,
  animation: PropTypes.object.isRequired,
  isLoop: PropTypes.bool,
  isAuto: PropTypes.bool,
  speed: PropTypes.string,
  direction: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

LottieControl.defaultProps = {
  playState: "playing",
  isLoop: true,
  isAuto: true,
  speed: "1",
  direction: "1",
  width: "100%",
  height: "100%",
};
